module.exports = __webpack_public_path__ + "r-v3/img/ml_22_01.9b512904.jpg";